
<div class="category" *ngIf="category && category.active">
  <div *ngIf="sortedFoods.length || sortedDrinks.length">
    <!-- category title -->
    <div class="category-title">
      <h1>{{ category | titleTranslate }}</h1>
    </div>
  </div>

  <div class="product-grid">
    <!-- FOODS -->
    <div class="product-grid-cell" *ngFor="let food of sortedFoods; let i = index; let last = last">
      <app-food-card [food]="food" [isLast]="last && isLastCategory && sortedDrinks.length === 0" [stoplist]="stoplistFoods.includes(food.id)"></app-food-card>
    </div>

    <!-- DRINKS -->
    <div class="product-grid-cell" *ngFor="let drink of sortedDrinks; let i = index; let last = last">
      <app-drink-card [drink]="drink" [isLast]="last && isLastCategory" [stoplist]="stoplistDrinks.includes(drink.id)"></app-drink-card>
    </div>
  </div>
</div>

